import React, { useEffect, useState } from "react";

import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import TouchAppIcon from "@mui/icons-material/TouchApp";
import AssessmentIcon from "@mui/icons-material/Assessment";
import PropTypes from "prop-types";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import SettingsSuggestIcon from "@mui/icons-material/SettingsSuggest";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

import { useNavigate } from "react-router-dom";

import FeeProceedingsHeaders from "./FeeProceedingsHeaders";

// future components
// import ScriptAllocation from "./ScriptAllocation";
// import ScriptScrutiny from "./ScriptScrutiny";
// import ValuationSummary from "./ValuationSummary";

function Scholarship() {
  const [loading, setLoading] = useState(true);
  const [activeView, setActiveView] = useState("home");

  // ACTIONS tab default
  const [tabValue, setTabValue] = useState(0);

  const navigate = useNavigate();

  useEffect(() => {
    setLoading(false);
  }, []);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const MenuCard = ({ title, icon, path, color = "#2196F3" }) => (
    <Grid item xs={12} sm={6} md={4} lg={3}>
      <MDButton
        fullWidth
        variant="gradient"
        size="large"
        startIcon={icon}
        sx={{
          height: 90,
          fontSize: "0.9rem",
          fontWeight: 700,
          letterSpacing: "0.3px",
          borderRadius: "12px",
          color: "#FFFFFF !important",
          background: `linear-gradient(135deg, ${color} 0%, ${color}CC 100%)`,
          boxShadow: `0 4px 12px ${color}40`,
          transition: "all 0.25s ease",
          "&:hover": {
            background: `linear-gradient(135deg, ${color} 0%, ${color}DD 100%)`,
            transform: "translateY(-4px)",
            boxShadow: `0 8px 20px ${color}60`,
          },
          "& .material-icons-round, & .material-icons": {
            fontSize: "28px",
            color: "#FFFFFF !important",
          },
          "& .MuiSvgIcon-root": {
            fontSize: "28px",
            color: "#FFFFFF",
          },
        }}
        onClick={() => handleNavigate(path)}
      >
        {title}
      </MDButton>
    </Grid>
  );

  MenuCard.propTypes = {
    title: PropTypes.string.isRequired,
    icon: PropTypes.node,
    path: PropTypes.string.isRequired,
    color: PropTypes.string,
  };

  const handleNavigate = (path) => {
    const token = sessionStorage.getItem("token");

    if (!token) {
      navigate("/authentication/sign-in");
      return;
    }

    setActiveView(path);
  };

  const handleBack = () => {
    setActiveView("home");
  };

  const renderContent = () => {
    switch (activeView) {
      case "feeproceedingsheaders":
        return <FeeProceedingsHeaders />;

      // future
      // case "scriptallocation":
      //   return <ScriptAllocation />;

      // case "scriptscrutiny":
      //   return <ScriptScrutiny />;

      default:
        return (
          <>
            <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 3 }}>
              <Tabs
                value={tabValue}
                onChange={handleTabChange}
                variant="fullWidth"
                TabIndicatorProps={{
                  sx: {
                    backgroundColor: ["#2196F3", "#4CAF50", "#FF9800", "#9C27B0"][tabValue],
                    height: 5,
                    borderRadius: "4px 4px 0 0",
                  },
                }}
              >
                {[
                  {
                    label: "UPLOADS",
                    icon: <CloudUploadIcon />,
                    color: "#2196F3",
                    bgColor: "rgba(33, 150, 243, 0.10)",
                  },
                  {
                    label: "SETUP",
                    icon: <SettingsSuggestIcon />,
                    color: "#4CAF50",
                    bgColor: "rgba(76, 175, 80, 0.10)",
                  },
                  {
                    label: "ACTIONS",
                    icon: <TouchAppIcon />,
                    color: "#FF9800",
                    bgColor: "rgba(255, 152, 0, 0.12)",
                  },
                  {
                    label: "REPORTS",
                    icon: <AssessmentIcon />,
                    color: "#9C27B0",
                    bgColor: "rgba(156, 39, 176, 0.10)",
                  },
                ].map((item, index) => (
                  <Tab
                    key={item.label}
                    icon={item.icon}
                    iconPosition="top"
                    label={
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          gap: 0.2,
                        }}
                      >
                        <Box
                          component="span"
                          sx={{
                            fontSize: "1rem",
                            fontWeight: 700,
                            letterSpacing: "0.1px",
                            lineHeight: 1.5,
                          }}
                        >
                          {item.label}
                        </Box>

                        {tabValue === index && (
                          <KeyboardArrowDownIcon
                            sx={{
                              fontSize: 30,
                              color: item.color,
                              strokeWidth: 2,
                              filter: "drop-shadow(0 1px 1px rgba(0,0,0,0.25))",
                              mt: 0.2,
                            }}
                          />
                        )}
                      </Box>
                    }
                    sx={{
                      minHeight: 105,
                      py: 1.2,
                      fontWeight: 800,
                      color: `${item.color} !important`,
                      opacity: 1,
                      borderRadius: "10px 10px 0 0",
                      transition: "all 0.25s ease",
                      "& .MuiSvgIcon-root": {
                        fontSize: 34,
                        color: item.color,
                        transition: "transform 0.25s ease",
                      },
                      "&:hover": {
                        backgroundColor: item.bgColor,
                        "& > .MuiTab-iconWrapper": {
                          transform: "scale(1.12)",
                        },
                      },
                      ...(tabValue === index && {
                        backgroundColor: item.bgColor,
                      }),
                    }}
                  />
                ))}
              </Tabs>
            </Box>

            {/* ACTIONS */}
            {tabValue === 0 && (
              <Grid container spacing={2}>
                <MenuCard
                  title="FEE PROCEEDING HEADERS"
                  icon={<Icon>grading</Icon>}
                  path="feeproceedingsheaders"
                  color="#2196F3"
                />
              </Grid>
            )}
            {/* ACTIONS */}
            {tabValue === 1 && <Grid container spacing={2}></Grid>}
            {/* ACTIONS */}
            {tabValue === 2 && <Grid container spacing={2}></Grid>}

            {/* REPORTS */}
            {tabValue === 3 && <Grid container spacing={2}></Grid>}
          </>
        );
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <MDBox pt={2} pb={3}>
        {loading ? (
          <MDBox display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
            <CircularProgress color="info" />
          </MDBox>
        ) : (
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Card>
                {/* HEADER - Matching Library Management System card design */}
                <MDBox
                  mx={2}
                  mt={-1}
                  py={1}
                  px={2}
                  bgColor="info"
                  borderRadius="lg"
                  coloredShadow="info"
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  flexWrap="wrap"
                  gap={1}
                >
                  <MDBox display="flex" alignItems="center" gap={1}>
                    <Icon sx={{ color: "#FFFFFF" }}>fact_check</Icon>

                    <MDTypography variant="h6" color="white">
                      VALUATION
                    </MDTypography>
                  </MDBox>

                  {activeView !== "home" ? (
                    <MDButton
                      variant="contained"
                      onClick={handleBack}
                      startIcon={<Icon>arrow_back</Icon>}
                      sx={{
                        mb: 0,
                        color: "#FFFFFF",
                        backgroundColor: "rgba(255,255,255,0.18)",
                        "&:hover": {
                          backgroundColor: "rgba(255,255,255,0.28)",
                        },
                      }}
                    >
                      Back to Valuation
                    </MDButton>
                  ) : (
                    <MDButton
                      variant="contained"
                      onClick={() => navigate("/dashboard")}
                      startIcon={<Icon>dashboard</Icon>}
                      sx={{
                        mb: 0,
                        color: "#FFFFFF !important",
                        backgroundColor: "rgba(255,255,255,0.18) !important",
                        boxShadow: "none !important",
                        "& .material-icons": {
                          color: "#FFFFFF !important",
                        },
                        "&:hover": {
                          color: "#FFFFFF !important",
                          backgroundColor: "rgba(255,255,255,0.28) !important",
                          boxShadow: "none !important",
                        },
                        "&:focus": {
                          color: "#FFFFFF !important",
                          backgroundColor: "rgba(255,255,255,0.18) !important",
                        },
                        "&:active": {
                          backgroundColor: "rgba(255,255,255,0.28) !important",
                        },
                      }}
                    >
                      Dashboard
                    </MDButton>
                  )}
                </MDBox>

                {/* CONTENT */}
                <MDBox p={1}>{renderContent()}</MDBox>
              </Card>
            </Grid>
          </Grid>
        )}
      </MDBox>

      <MDBox display="flex" flexDirection="column" minHeight="50vh" />

      <Footer />
    </DashboardLayout>
  );
}

export default Scholarship;
